import { FuseHit } from "@kanda-libs/ks-design-library";
import useSearchQuery from "hooks/useSearchQuery";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";
import { selectors } from "store";
import { SEARCH_OPTIONS } from "../JobTable/constants";
import { JobWithCompanyAndCredit } from "../JobTable/types";
import { getQueryFlags } from "store/selectors/query";

export interface JobListPageHook {
  isLoading: boolean;
  solar: boolean;
  satNoteSigned: boolean;
  pendingPayout: boolean;
  hits: FuseHit<JobWithCompanyAndCredit>[];
  query: string;
  setQuery: (query: string) => void;
}

export default function useJobListPage(): JobListPageHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const flags = useSelector(getQueryFlags);
  const jobs = useSelector(jobSelectors.getFilteredJobs);

  const { hits, query, setQuery } = useSearchQuery(
    jobs,
    "jobs",
    SEARCH_OPTIONS
  );

  const { solar, satNoteSigned, pendingPayout } = flags.jobs;

  return {
    isLoading,
    solar,
    satNoteSigned,
    pendingPayout,
    hits,
    query,
    setQuery,
  };
}
